import { useState } from 'react';

export interface SectionError {
    error?: { message?: string };
    id: number;
}

export const useSectionErrors = () => {
    const [errors, setErrors] = useState<SectionError[]>([]);

    const onClearError = () => {
        setErrors((prevState) => {
            return prevState.slice(1);
        });
    };

    const onAddError = (error?: { message?: string }) => {
        setErrors((prevState) => {
            return [...prevState, { error, id: Date.now() }];
        });
    };

    return {
        onAddError,
        onClearError,
        errors,
    };
};
